export class WebPush {
    private registration: ServiceWorkerRegistration;
    private applicationServerKey: string;
    public async current() {
        return await this.registration.pushManager.getSubscription();
    }

    public async register() {
        const applicationServerKey = this.urlBase64ToUint8Array(this.applicationServerKey);
        const subscription = await this.registration.pushManager.subscribe({
            userVisibleOnly: true, // Musí být true
            applicationServerKey: applicationServerKey
        });

        return subscription;
    }

    constructor(registration: ServiceWorkerRegistration, applicationServerKey: string) {
        this.registration = registration;
        this.applicationServerKey = applicationServerKey;
    }

    protected urlBase64ToUint8Array(base64String: string): Uint8Array {
        const padding = '='.repeat((4 - base64String.length % 4) % 4);
        const base64 = (base64String + padding)
            .replace(/\-/g, '+')
            .replace(/_/g, '/');

        const rawData = atob(base64);
        const outputArray = new Uint8Array(rawData.length);

        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    }
}